module.exports = __webpack_public_path__ + "static/media/cash-for-used-car-brisbane.cff5860c.png";